import React from "react";
import { Container, Button } from "rsuite";
import { useTranslation } from "react-i18next";
import NotFoundImage from "../../../icons/404-bg.jpg";
import { useNavigate } from "react-router-dom";
import { ContentRoutes } from "../../../navigation/NavConstant";

export function Page404() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate(ContentRoutes.DASHBOARD);
  };

  return (
    <div className="users error-pg">
      <Container className="container">
        <div className="row mb-2" style={{height: "calc(100vh - 5vh)", display: "flex", alignItems: "center"}}>
          <div className="col-md-4 offset-1">
            <img src={NotFoundImage} alt="404 Page not found" />
          </div>
          <div className="col-md-5 offset-1">
            <h1 className="mb-0">404</h1>
            <h3 className="txt-rd">Error</h3>
            <h4 className="mb-3 mt-1">Opps! Something went wrong.</h4>
            <p>
              Huge appologies for making you good hair day terrible <br />
              Sadly, the page you're looking for might have been doing its
              <br />
              hair and makeup at the moment. <br />
              <small>
                {" "}
                But we would like to make it up to you, contact us if you need
                Something.
              </small>
            </p>
            <div className="mt-3">
              <Button
                className="rs-btn"
                appearance="primary"
                onClick={handleRedirect}
              >
                {t("Home")}
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
